@let totalCount = totalCount$ | async;
@let isCritical = isCritical$ | async;
@let badgeValue = totalCount !== 0 ? totalCount : undefined;
@let canI= canI$ | async;

@if (canI) {
    <button mat-icon-button appFixedOverlay
            [overlayContent]="alertsOverlay"
            [overlayPosition]="overlayPosition"
            [hasBackdrop]="true"
            [matBadge]="badgeValue"
            [class.hasCriticalAlerts]="isCritical"
    >
        <mat-icon>notifications</mat-icon>
    </button>
}

<ng-template #alertsOverlay>
    <mat-card>
        <mat-card-header>
            {{ "shared.alerts.title" | translate }}
        </mat-card-header>
        <mat-card-content>
            @let alerts = alerts$ | async;

            @if (alerts?.length === 0) {
                <div>
                    {{ "shared.alerts.empty-list" | translate }}
                </div>
            }

            @for (alert of alerts; track alert.id) {
                <div class="alert-menu-item">
                    <div class="alert-menu-header">
                        <mat-icon>warning</mat-icon>
                        <span class="alert-title">
                            {{ alert.dropPoint?.name }}
                        </span>
                    </div>
                    <span>
                        {{ alert.description }}
                    </span>
                    <span class="timestamp">
                        {{ alert.dateDebut | dateModel : "yyyy/MM/dd HH:mm" }}
                    </span>
                </div>
            }

        </mat-card-content>
        <mat-card-footer>
            <button mat-button [routerLink]="['/', 'workspace', 'alerts']">
                {{ "shared.alerts.show-all" | translate }}
            </button>
        </mat-card-footer>
    </mat-card>

</ng-template>
